/** Authored ferry identities. Browser requests name an NPC/action only;
 * destinations are resolved again by the server and checked against the map. */
export type NpcFerryActionId = 'board_ferry';
export interface NpcFerryRequest { npcId: string; actionId: NpcFerryActionId }
export interface NpcFerryOffer { actionId: NpcFerryActionId; label: string }
export interface NpcFerryRoute extends NpcFerryRequest {
  sourceMapId: string;
  portalId: string;
  mapId: string;
  spawnId: string;
  label: string;
}

export const NPC_FERRY_ROUTES: readonly Readonly<NpcFerryRoute>[] = Object.freeze([
  Object.freeze({ sourceMapId: 'tidewend_port', npcId: 'tidewend_ferrymaster', actionId: 'board_ferry' as const,
    portalId: 'ferry_to_wickhaven', mapId: 'wickhaven_port', spawnId: 'ferry_to_tidewend', label: 'Sail to Wickhaven' }),
  Object.freeze({ sourceMapId: 'wickhaven_port', npcId: 'wickhaven_ferrymaster', actionId: 'board_ferry' as const,
    portalId: 'ferry_to_tidewend', mapId: 'tidewend_port', spawnId: 'ferry_to_wickhaven', label: 'Sail to Tidewend' }),
]);

export function npcFerryRoute(sourceMapId: string | undefined, npcId: string, actionId: string): Readonly<NpcFerryRoute> | undefined {
  return NPC_FERRY_ROUTES.find(route => route.sourceMapId === sourceMapId && route.npcId === npcId && route.actionId === actionId);
}
export function isNpcOnlyFerryPortal(sourceMapId: string | undefined, portalId: unknown): boolean {
  return NPC_FERRY_ROUTES.some(route => route.sourceMapId === sourceMapId && route.portalId === portalId);
}
export function npcFerryOffer(sourceMapId: string | undefined, npcId: string): NpcFerryOffer | undefined {
  const route = npcFerryRoute(sourceMapId, npcId, 'board_ferry');
  return route ? { actionId: route.actionId, label: route.label } : undefined;
}
